import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';
import T6 from "../../components/ExcerciseTypes/TypeIn/T6";

const json = {

  1: { // Exercise num
    unit: 'Unit 6',
    id: 'WB3-U6-P41-E1',
    audio: '',
    video: '',
    exerciseKey: 'img/FriendsPlus/Page41/E1/Key/answerKey.png',
    component: D1,
    checkUppercase: true,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page41/E1/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page41/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page41/E1/3.jpg', input: true, answer: "It's three o'clock." },
        { url: 'img/FriendsPlus/Page41/E1/4.jpg' },
        { url: 'img/FriendsPlus/Page41/E1/5.jpg', input: true, answer: "It's ten o'clock." },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page41/E1/6.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page41/E1/7.jpg' },
        { url: 'img/FriendsPlus/Page41/E1/8.jpg', input: true, answer: "It's six o'clock." },
        { url: 'img/FriendsPlus/Page41/E1/9.jpg' },
        { url: 'img/FriendsPlus/Page41/E1/10.jpg', input: true, answer: "It's one o'clock." },
        { url: 'img/FriendsPlus/Page41/E1/11.jpg' },
        { url: 'img/FriendsPlus/Page41/E1/12.jpg', input: true, answer: "It's twelve o'clock." },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page41/E1/13.jpg' },
      ],


    ],
  },
  2: { // Exercise num
    unit: 'Unit 6',
    id: 'WB3-U6-P41-E2',
    audio: 'img/FriendsPlus/Page41/Audio/audio-e2-p41.mp3',
    video: '',
    component: DesignUnderLine,
    totalInput: 3,
    exerciseKey: 'img/FriendsPlus/Page41/E2/Key/answerKey.png',
    titleImage: '',
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page41/E2/1.jpg' },
        { url: 'img/FriendsPlus/Page41/E2/2.jpg', audioUrl: 'img/FriendsPlus/Page41/Audio/tieude-e2-p41.mp3' },
        { url: 'img/FriendsPlus/Page41/E2/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page41/E2/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page41/E2/5.jpg' },
        { url: 'img/FriendsPlus/Page41/E2/6.jpg', input: 1 },
        { url: 'img/FriendsPlus/Page41/E2/7.jpg' },
        { url: 'img/FriendsPlus/Page41/E2/8.jpg', input: 1, isCorrect: true },
        { url: 'img/FriendsPlus/Page41/E2/9.jpg' },
        { url: 'img/FriendsPlus/Page41/E2/10.jpg', input: 1 },
        { url: 'img/FriendsPlus/Page41/E2/11.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page41/E2/12.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page41/E2/13.jpg' },
        { url: 'img/FriendsPlus/Page41/E2/14.jpg', input: 2 },
        { url: 'img/FriendsPlus/Page41/E2/15.jpg' },
        { url: 'img/FriendsPlus/Page41/E2/16.jpg', input: 2 },
        { url: 'img/FriendsPlus/Page41/E2/17.jpg' },
        { url: 'img/FriendsPlus/Page41/E2/18.jpg', input: 2, isCorrect: true },
        { url: 'img/FriendsPlus/Page41/E2/19.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page41/E2/20.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page41/E2/21.jpg' },
        { url: 'img/FriendsPlus/Page41/E2/22.jpg', input: 3, isCorrect: true },
        { url: 'img/FriendsPlus/Page41/E2/23.jpg' },
        { url: 'img/FriendsPlus/Page41/E2/24.jpg', input: 3 },
        { url: 'img/FriendsPlus/Page41/E2/25.jpg' },
        { url: 'img/FriendsPlus/Page41/E2/26.jpg', input: 3 },
        { url: 'img/FriendsPlus/Page41/E2/27.jpg' },
      ],
      [
        // Column8
        { url: 'img/FriendsPlus/Page41/E2/28.jpg' },
      ],

    ]
  },
  3: { // Exercise num
    unit: 'Unit 6',
    id: 'WB3-U6-P41-E3',
    audio: '',
    video: '',
    component: T6,
    exerciseKey: 'img/FriendsPlus/Page41/E3/Key/answerKey.png',
    inputSize: 450,
    checkUppercase: true,
    // titleImage: 'img/FriendsPlus/Page21/E1/title.jpg',
    titleQuestion: [{ num: '3', title: 'Now write the sentences in the correct order.', color: "#5B5A5D" }],
    questionImage: [],
    questions: [
      {
        title:
          `
          <div style='display:flex;'>
            <div style='margin-right:30px'>
              <div><b>1</b>  <u style='color: gray;'><i> He gets up at six o'clock. </i></u></div>
              <div><b>3</b> # </div>
              </div>
              <div >
                <div><b>2</b> He # </div>
                <div ><b style='margin-right:37px;'>4</b> # </div>
             </div>
          </div>
          `,
        answer: [
          "He goes to school at eight o'clock.",
          "has breakfast at seven o'clock.",
          "He has dinner at six o'clock.",
        ],
      },
    ]
  },


}

export default json;